import { Switch as CXSwitch } from '@sanlamcx/react-ui-next-switch';

export const Switch = CXSwitch;
